export default __webpack_public_path__ + "static/media/accepted.1f1c8e80.svg";